import { useTranslation } from "react-i18next";
import { useBlocker } from "react-router";
import { Button, Sheet } from "../../ui/index.js";
import { shouldBlockNavigation, useBeforeUnloadGuard } from "./unsaved.js";

/**
 * Защита правок на странице вне мастера настройки (график мастера, «Данные салона и правила»):
 * `blockRoutes`: уход на другой маршрут кабинета спрашивает «Остаться» / «Уйти» (шторка как в мастере);
 * `blockUnload`: закрытие и перезагрузку вкладки предупреждает браузер (`beforeunload`).
 */
export function LeaveGuard({ blockRoutes, blockUnload }: { blockRoutes: boolean; blockUnload: boolean }) {
  const { t } = useTranslation();
  const blocker = useBlocker(({ currentLocation, nextLocation }) => shouldBlockNavigation(blockRoutes, currentLocation.pathname, nextLocation.pathname));
  useBeforeUnloadGuard(blockUnload);
  return (
    <Sheet open={blocker.state === "blocked"} onClose={() => blocker.reset?.()} title={t("onb.unsaved.title")}>
      <p className="text-ink-2">{t("onb.unsaved.text")}</p>
      <div className="mt-4 flex gap-2">
        <Button variant="secondary" className="flex-1" onClick={() => blocker.proceed?.()}>
          {t("onb.unsaved.leave")}
        </Button>
        <Button className="flex-1" onClick={() => blocker.reset?.()}>
          {t("onb.unsaved.stay")}
        </Button>
      </div>
    </Sheet>
  );
}
